import Vue from 'vue'
import Router from 'vue-router'
import main from '@/pages/main'

import index from '@/pages/index'

import introduction from '@/pages/group/introduction'
import speech from '@/pages/group/speech'
import culture from '@/pages/group/culture'
import team from '@/pages/group/team'
import contexts from '@/pages/group/contexts'

import newsNotice from '@/pages/news/newsNotice'
import newsDetail from '@/pages/news/newsDetail'

import realty from '@/pages/business/realty'
import realtyDetail from '@/pages/business/realtyDetail'
import subsidiary from '@/pages/business/subsidiary'
import subsidiaryDetail from '@/pages/business/subsidiaryDetail'

import course from '@/pages/development/course'
import bigEvents from '@/pages/development/events'

import personnelIdea from '@/pages/recruit/personnel-idea'
import personnelRecruit from '@/pages/recruit/personnel-recruit'

import headquarters from '@/pages/contact/headquarters'
import report from '@/pages/contact/report'
import reportDetail from '@/pages/contact/reportDetail'

import searchResult from '@/pages/searchResult'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/main/index'
    },
    {
      path: '/main',
      name: 'main',
      component: main,
      children: [
        {
          path:'index',
          name:'首页',
          component:index
        },{
          path:'group/introduction',
          name:'集团介绍',
          component:introduction
        },{
          path:'group/speech',
          name:'董事长致辞',
          component:speech
        },{
          path:'group/culture',
          name:'企业文化',
          component:culture
        },{
          path:'group/team',
          name:'团队介绍',
          component:team
        },{
          path:'group/contexts',
          name:'企业背景',
          component:contexts
        },{
          path:'newsNotice',
          name:'新闻公告',
          component:newsNotice
        }, {
          path:'newsNotice/newsDetail',
          name:'新闻公告详情',
          component:newsDetail
        },{
          path:'business/realty',
          name:'房地产开发',
          component:realty
        },{
          path:'business/realtyDetail',
          name:'房地产开发详情',
          component:realtyDetail
        },{
          path:'business/subsidiary',
          name:'旗下子公司',
          component:subsidiary
        },{
          path:'business/subsidiaryDetail',
          name:'旗下子公司详情',
          component:subsidiaryDetail
        },{
          path:'development/course',
          name:'成长历程',
          component:course
        },{
          path:'development/bigEvents',
          name:'大事记',
          component:bigEvents
        },{
          path:'recruit/personnelIdea',
          name:'人才理念',
          component:personnelIdea
        },{
          path:'recruit/personnelRecruit',
          name:'人才招聘',
          component:personnelRecruit
        },{
          path:'contact/headquarters',
          name:'联系总部',
          component:headquarters
        },{
          path:'contact/report',
          name:'廉洁举报',
          component:report
        },{
          path:'contact/reportDetail',
          name:'霏凡集团商业行为准则',
          component:reportDetail
        },{
          path:'searchResult',
          name:'搜索结果页',
          component:searchResult
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js